import { useState, useEffect } from 'react';
import {
  Box,
  Typography,
  FormControlLabel,
  Checkbox,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  Paper,
  Link,
} from '@mui/material';
import { Trans, useTranslation } from 'react-i18next';
import i18next from 'i18next';
import ConfirmacaoCadastroProdutorDialog from '../../../components/dialogs/confirmacao-cadastro/ConfirmacaoCadastroProdutorDialog';

const IDIOMAS = [
  { value: 'pt-BR', label: '🇧🇷 Português' },
  { value: 'en-US', label: '🇺🇸 English' },
  { value: 'es-ES', label: '🇪🇸 Español' },
];

function Step1IdiomaLGPD({ data, onChange }) {
  const { t } = useTranslation();
  const [dialogOpen, setDialogOpen] = useState(false);

  // Ao montar, força o i18n a usar o idioma selecionado no wizard
  // (pode ter sido sobrescrito pelo AuthContext ou pelo idioma do navegador)
  useEffect(() => {
    const idioma = data.idioma || 'pt-BR';
    const lang = idioma.split('-')[0].toLowerCase();
    window.localStorage.setItem('konq.idioma', lang);
    i18next.changeLanguage(lang);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const handleIdiomaChange = (e) => {
    const newIdioma = e.target.value;
    const lang = newIdioma.split('-')[0].toLowerCase();
    window.localStorage.setItem('konq.idioma', lang);
    i18next.changeLanguage(lang);
    onChange({ ...data, idioma: newIdioma });
  };

  const handleCheckboxClick = () => {
    // Se está desmarcando, desmarca diretamente
    if (data.lgpdAceito) {
      onChange({ ...data, lgpdAceito: false });
      return;
    }
    // Se está marcando, abre o dialog de confirmação
    setDialogOpen(true);
  };

  const handleDialogConfirm = () => {
    setDialogOpen(false);
    onChange({ ...data, lgpdAceito: true });
  };

  const handleDialogClose = () => {
    setDialogOpen(false);
  };

  return (
    <Box>
      <Typography variant="h5" gutterBottom textAlign="center">
        {t('wizard.step1.title')}
      </Typography>
      <Typography variant="body2" mb={4} textAlign="center">
        {t('wizard.step1.subtitle')}
      </Typography>

      {/* Seletor de idioma */}
      <FormControl fullWidth sx={{ mb: 3 }}>
        <InputLabel>{t('wizard.step1.idiomaLabel')}</InputLabel>
        <Select value={data.idioma || 'pt-BR'} label={t('wizard.step1.idiomaLabel')} onChange={handleIdiomaChange}>
          {IDIOMAS.map((op) => (
            <MenuItem key={op.value} value={op.value}>
              {op.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      {/* Política de Privacidade / LGPD */}
      <Paper variant="outlined" sx={{ p: 2.5, mb: 2, borderRadius: 2, bgcolor: 'grey.50' }}>
        <Typography variant="subtitle2" fontWeight={600} gutterBottom>
          {t('wizard.step1.lgpd.title')}
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 1.5 }}>
          <Trans i18nKey="wizard.step1.lgpd.body" components={{ b: <strong /> }} />
        </Typography>
        <Link
          href="#"
          variant="body2"
          underline="hover"
          onClick={(e) => {
            e.preventDefault();
            setDialogOpen(true);
          }}
        >
          {t('wizard.step1.lgpd.link')}
        </Link>
      </Paper>

      <FormControlLabel
        control={<Checkbox checked={data.lgpdAceito || false} onChange={handleCheckboxClick} color="primary" />}
        label={
          <Typography variant="body2">
            <Trans i18nKey="wizard.step1.lgpd.agree" components={{ b: <strong /> }} />
          </Typography>
        }
      />

      <ConfirmacaoCadastroProdutorDialog
        open={dialogOpen}
        onClose={handleDialogClose}
        setChecked={handleDialogConfirm}
      />
    </Box>
  );
}

export default Step1IdiomaLGPD;
